export default __webpack_public_path__ + "static/media/shieldslam.8fd77699.png";